import { render, staticRenderFns } from "./NewOptionBase.vue?vue&type=template&id=13f30e1c"
import script from "./NewOptionBase.vue?vue&type=script&lang=js"
export * from "./NewOptionBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports